// Controls component for simulation actions and settings

import React from 'react';
import Icon from '../../../core/Icon';
import { ControlsContainer, Button, Label, Input } from '../styles';

interface ControlsProps {
  isRunning: boolean;
  signalStrength: number;
  pingInterval: number;
  creatingPatients: boolean;
  initializingStaffBeacons: boolean;
  onToggleSimulation: () => void;
  onSendOnce: () => void;
  onInitializeGateways: () => void;
  onCreatePatients: () => void;
  onInitializeStaffBeacons: () => void;
  onClearLocations: () => void;
  onSignalStrengthChange: (value: number) => void;
  onPingIntervalChange: (value: number) => void;
}

export const Controls: React.FC<ControlsProps> = ({
  isRunning,
  signalStrength,
  pingInterval,
  creatingPatients,
  initializingStaffBeacons,
  onToggleSimulation,
  onSendOnce,
  onInitializeGateways,
  onCreatePatients,
  onInitializeStaffBeacons,
  onClearLocations,
  onSignalStrengthChange,
  onPingIntervalChange,
}) => (
  <ControlsContainer>
    <Button primary onClick={onToggleSimulation}>
      <Icon className="material-icons">{isRunning ? 'pause' : 'play_arrow'}</Icon>
      {isRunning ? 'Stop' : 'Start'} Simulation
    </Button>

    <Button onClick={onSendOnce} disabled={isRunning}>
      <Icon className="material-icons">sync</Icon>
      Send Once
    </Button>

    <Button onClick={onInitializeGateways}>
      <Icon className="material-icons">settings</Icon>
      Initialize Gateways
    </Button>

    <Button onClick={onCreatePatients} disabled={creatingPatients} style={{ background: '#4CAF50' }}>
      <Icon className="material-icons">{creatingPatients ? 'hourglass_empty' : 'person_add'}</Icon>
      {creatingPatients ? 'Creating...' : 'Create Test Patients'}
    </Button>

    <Button onClick={onInitializeStaffBeacons} disabled={initializingStaffBeacons} style={{ background: '#3F51B5' }}>
      <Icon className="material-icons">{initializingStaffBeacons ? 'hourglass_empty' : 'badge'}</Icon>
      {initializingStaffBeacons ? 'Assigning...' : 'Assign Staff Beacons'}
    </Button>

    <Button danger onClick={onClearLocations}>
      <Icon className="material-icons">clear_all</Icon>
      Clear All Locations
    </Button>

    <Label>
      Signal (dBm):
      <Input
        type="number"
        value={signalStrength}
        onChange={e => onSignalStrengthChange(parseInt(e.target.value) || -50)}
        min="-100"
        max="-20"
      />
    </Label>

    <Label>
      Interval (ms):
      <Input
        type="number"
        value={pingInterval}
        onChange={e => onPingIntervalChange(parseInt(e.target.value) || 1000)}
        min="500"
        max="10000"
        step="500"
      />
    </Label>
  </ControlsContainer>
);
